
import React from "react";
import { FormField, FormItem, FormLabel, FormControl, FormMessage, FormDescription } from "@/components/ui/form";
import { UseFormReturn } from "react-hook-form";
import { CheckIcon } from "lucide-react";
import { roleOptions } from "../formSchema";

interface RoleSelectorProps {
  form: UseFormReturn<any>;
}

export function RoleSelector({ form }: RoleSelectorProps) {
  return (
    <FormField
      control={form.control}
      name="role"
      render={({ field }) => (
        <FormItem>
          <FormLabel>Your Role <span className="text-red-500">*</span></FormLabel>
          <FormDescription>Select the role that best describes your position</FormDescription>
          <FormControl>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-2">
              {roleOptions.map((option) => (
                <div
                  key={option.value}
                  className={`p-3 border rounded-md cursor-pointer flex items-center space-x-2 
                    ${field.value === option.value ? "border-primary bg-primary/10" : "border-border"}`}
                  onClick={() => form.setValue("role", option.value, { shouldValidate: true })}
                >
                  {field.value === option.value && (
                    <CheckIcon className="h-4 w-4 text-primary" />
                  )}
                  <span>{option.label}</span>
                </div>
              ))}
            </div>
          </FormControl>
          <FormMessage />
        </FormItem>
      )}
    />
  );
}
